var React = require('react');

function YoutubeFindInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M41.3451 0.978823C43.3321 1.50588 44.8988 3.04941 45.4337 5.00706C46.4272 8.58353 46.389 16.0376 46.389 16.0376C46.389 16.0376 46.389 23.4541 45.4337 27.0306C44.8988 28.9882 43.3321 30.5318 41.3451 31.0588C37.715 32 23.1945 32 23.1945 32C23.1945 32 8.71227 32 5.04395 31.0212C3.05694 30.4941 1.49026 28.9506 0.955293 26.9929C0 23.4541 0 16 0 16C0 16 0 8.58353 0.955293 5.00706C1.49026 3.04941 3.09515 1.46824 5.04395 0.941176C8.67406 0 23.1945 0 23.1945 0C23.1945 0 37.715 0 41.3451 0.978823ZM30.6464 16.0001L18.5715 9.14829V22.8518L30.6464 16.0001Z","fill":"black"}));
}

YoutubeFindInline.defaultProps = {"width":"47","height":"32","viewBox":"0 0 47 32","fill":"none"};

module.exports = YoutubeFindInline;

YoutubeFindInline.default = YoutubeFindInline;
